import { ParentEmailFormFields } from 'types';
import { EmailInputElement, FormNavButtons, AppModal, AppModalProps } from 'components/molecules';
import { AppModalForm, AppModalFormProps } from 'components/organisms';
import { childrenTexts, commonTexts } from 'consts/text';
import { useTheme } from 'styled-components';

type ParentEmailModalEditFormProps = Pick<AppModalProps, 'open' | 'onCancel'> &
    Omit<
        AppModalFormProps<ParentEmailFormFields>,
        'withGoBack' | 'width' | 'name' | 'mode' | 'onFinish'
    > & {
        onSubmitForm: (values: ParentEmailFormFields) => void;
    };

export const ParentEmailModalEditForm = ({
    open,
    onCancel,
    onSubmitForm,
    initialValues,
    ...props
}: ParentEmailModalEditFormProps) => {
    const theme = useTheme();

    return (
        <AppModal
            title={childrenTexts.childDetails.parents.parentTable.parentEmailEditModalTitle}
            width={theme.sizes.modalWidth.medium}
            open={open}
            onCancel={onCancel}
            destroyOnClose
        >
            <AppModalForm<ParentEmailFormFields>
                name="parentEmailEdit"
                onFinish={onSubmitForm}
                initialValues={initialValues}
                {...props}
            >
                <EmailInputElement />
                <FormNavButtons
                    formValuesBeforeChanges={initialValues}
                    buttonText={commonTexts.actionLabels.save}
                    withDeviceFloppy
                    marginBottom={0}
                />
            </AppModalForm>
        </AppModal>
    );
};
